type TWindow = typeof window;

export const anyWindow = window as TWindow & { [key: string]: any };

export function toInt(x) {
    return parseInt(x, 10) || 0;
}
